/* eslint-disable import/prefer-default-export */
import * as home from './home'
import * as search from './search'
import * as user from './user'
import * as movieDetail from './movie-detail'
import * as recommendation from './recommendation'
import * as subscribe from './subscribe'
import * as matches from './matches'
import * as feature from './feature'
import * as playlist from './playlist'
import * as partners from './partners'
import * as notifications from './notifications'
import * as articlesDetail from './articles'
import * as promo from './promo'
import * as refund from './refund'
import * as alert from './alert'
import * as inbox from './inbox'
import * as standings from './standings'
import * as reminders from './reminders'
import * as snackbarFavorite from './snackbar-favorite'
import * as molaHub from './mola-hub'

const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE'
export default {
  SET_RUNTIME_VARIABLE,
  ...home,
  ...search,
  ...user,
  ...movieDetail,
  ...recommendation,
  ...subscribe,
  ...matches,
  ...feature,
  ...playlist,
  ...partners,
  ...notifications,
  ...articlesDetail,
  ...promo,
  ...refund,
  ...alert,
  ...inbox,
  ...standings,
  ...reminders,
  ...snackbarFavorite,
  ...molaHub,
}
